import React from 'react';

const MarkerPopupLoader = () => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <div
        style={{
          width: '16px',
          height: '16px',
          border: '2px solid #006AF9',
          borderTop: '2px solid transparent',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
        }}
      ></div>
      Loading...
    </div>
  );
};

export default MarkerPopupLoader;
